module.exports = __webpack_public_path__ + "img/ic_social_spielerplus.2cb87318.svg";